module.exports = __webpack_public_path__ + "img/image-1.f40e4810.png";